// https://shouts.dev/easiest-way-to-paginate-an-array-in-javascript
export function paginate(array, currentPage, perPage) {
  currentPage = currentPage || 1
  perPage = perPage || 10

  const offsetStart = (currentPage - 1) * perPage
  const offsetEnd = currentPage * perPage
  const data = array.slice(offsetStart, offsetEnd)
  const totalPages = Math.ceil(array.length / perPage)
  const total = array.length

  return {
    currentPage,
    perPage,
    data,
    totalPages,
    offsetStart: offsetStart + 1,
    offsetEnd: Math.min(offsetEnd, total),
    previousPage: currentPage - 1 ? currentPage - 1 : null,
    nextPage: totalPages > currentPage ? currentPage + 1 : null,
    total,
  }
}

// Array.prototype.paginate = function (currentPage, perPage) {

// }
